import axios from "axios";
import Helper from "../helper";

let token, applicationId;
if (localStorage.getItem('user')) {
    const user = JSON.parse(localStorage.getItem('user'));
    token = user.token;
    applicationId = user.application_id
}

const headers = {
    "TOKEN": token
}

const Application = {
    applicationInfo: () => {
        if (!applicationId) {
            localStorage.removeItem('user');
            localStorage.removeItem('formCount');
            window.location.href = '/';
        }
        return new Promise((resolve, reject) => {
            axios.post(`${process.env.REACT_APP_API_URL}/api/application/info/${applicationId}`, null, {
                headers: headers
            }).then(results => {
                var res = results.data;
                if (res.success === true) {
                    if (res.data.application && res.data.application.status && (res.data.application.status != 'P' && res.data.application.status != 'S')) {
                        localStorage.setItem('formCount', 7)
                    }
                    resolve(res)
                } else {
                    reject()
                    Helper.error(res.message);
                }
            }).catch(function (error) {
                reject()
                console.log(error);
            });
        });
    },
    applicationUpdate: (formData) => {
        return new Promise((resolve, reject) => {
            axios.post(`${process.env.REACT_APP_API_URL}/api/application/update/${applicationId}`, formData, {
                headers: headers
            }).then(results => {
                var res = results.data;
                if (res.success === true) {
                    resolve(res)
                } else {
                    Helper.validationError(res);
                    reject()
                }
            }).catch(function (error) {
                reject()
                console.log(error);
            });
        });
    },
    Submit: (formData) => {
        return new Promise((resolve, reject) => {
            axios.post(`${process.env.REACT_APP_API_URL}/api/application/submit/${applicationId}`, formData, {
                headers: headers
            }).then(results => {
                var res = results.data;
                resolve(res)
            }).catch(function (error) {
                reject()
                console.log(error);
            });
        });
    },
    fetchIdData: formData => {
        return new Promise((resolve, reject) => {
            axios.post(`${process.env.REACT_APP_API_URL}/api/fetch/id-info`, formData, {
                headers: headers
            }).then(results => {
                resolve(results.data)
            }).catch(function (error) {
                reject()
                console.log(error);
            });
        });
    }
}

export default Application;